import { useState, useEffect } from 'react';
import { InstagramIcon, FacebookIcon, LinkedInIcon } from './Icons';
import { LanguageSwitcher } from './LanguageSwitcher';
import { useLanguage } from '../contexts/LanguageContext';

export default function Header() {
  const { t } = useLanguage();
  const [scrolled, setScrolled] = useState(false);
  const [hidden, setHidden] = useState(false);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      setScrolled(currentScrollY > 10);

      // Hide/show header on mobile
      if (window.innerWidth <= 768) {
        const scrollDiff = currentScrollY - lastScrollY;

        if (scrollDiff > 10 && currentScrollY > 100) {
          setHidden(true);
          setMenuOpen(false);
        } else if (scrollDiff < -10) {
          setHidden(false);
        }
      } else {
        setHidden(false);
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollY]);

  // Menü açıkken scroll engelle
  useEffect(() => {
    if (menuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [menuOpen]);

  const toggleMenu = () => setMenuOpen(!menuOpen);
  const closeMenu = () => setMenuOpen(false);

  return (
    <>
      <header className={`header ${scrolled ? 'scrolled' : ''} ${hidden ? 'header-hidden' : ''}`}>
        <div className="header-inner">
          <a href="https://sibuzhome.com" target="_blank" rel="noopener noreferrer" className="logo">
            <img src="/logodeneme5-scaled.png" alt="Sibuzhome" className="logo-img" />
          </a>

          <nav className="header-nav">
            <a href="https://sibuzhome.com/portfolio/uyku-seti/" target="_blank" rel="noopener noreferrer" className="nav-link">{t('header.products')}</a>
            <a href="https://sibuzhome.com/fuarlar/" target="_blank" rel="noopener noreferrer" className="nav-link">{t('header.fairs')}</a>
            <a href="https://sibuzhome.com/hakkimizda" target="_blank" rel="noopener noreferrer" className="nav-link">{t('header.about')}</a>
            <a href="https://sibuzhome.com/satis-noktalarimiz/" target="_blank" rel="noopener noreferrer" className="nav-link">{t('header.salesPoints')}</a>
            <a href="https://sibuzhome.com/iletisim" target="_blank" rel="noopener noreferrer" className="nav-link">{t('header.contact')}</a>
          </nav>

          <div className="header-actions">
            <LanguageSwitcher />
            <div className="social-links">
              <a href="https://www.instagram.com/sibuzhome/" target="_blank" rel="noopener noreferrer" className="social-link">
                <InstagramIcon />
              </a>
              <a href="https://www.facebook.com/profile.php?id=61581253865686" target="_blank" rel="noopener noreferrer" className="social-link">
                <FacebookIcon />
              </a>
              <a href="https://www.linkedin.com/company/sibuzhome" target="_blank" rel="noopener noreferrer" className="social-link">
                <LinkedInIcon />
              </a>
            </div>
            <a href="https://sibuzhome.com/e-katalog" target="_blank" rel="noopener noreferrer" className="btn-catalog">{t('header.catalog')}</a>
          </div>

          {/* Hamburger Menu Button - only visible on mobile */}
          <button
            className={`mobile-menu-btn ${menuOpen ? 'active' : ''}`}
            onClick={toggleMenu}
            aria-label="Menu"
          >
            <span className="hamburger-line"></span>
            <span className="hamburger-line"></span>
            <span className="hamburger-line"></span>
          </button>
        </div>
      </header>

      {/* Mobile Menu Overlay */}
      <div className={`mobile-menu-overlay ${menuOpen ? 'active' : ''}`} onClick={closeMenu} />

      {/* Mobile Menu Panel */}
      <div className={`mobile-menu ${menuOpen ? 'active' : ''}`}>
        <nav className="mobile-menu-nav">
          <a href="https://sibuzhome.com/portfolio/uyku-seti/" target="_blank" rel="noopener noreferrer" className="mobile-nav-link" onClick={closeMenu}>{t('header.products')}</a>
          <a href="https://sibuzhome.com/fuarlar/" target="_blank" rel="noopener noreferrer" className="mobile-nav-link" onClick={closeMenu}>{t('header.fairs')}</a>
          <a href="https://sibuzhome.com/hakkimizda" target="_blank" rel="noopener noreferrer" className="mobile-nav-link" onClick={closeMenu}>{t('header.about')}</a>
          <a href="https://sibuzhome.com/satis-noktalarimiz/" target="_blank" rel="noopener noreferrer" className="mobile-nav-link" onClick={closeMenu}>{t('header.salesPoints')}</a>
          <a href="https://sibuzhome.com/iletisim" target="_blank" rel="noopener noreferrer" className="mobile-nav-link" onClick={closeMenu}>{t('header.contact')}</a>
        </nav>

        <div className="mobile-menu-divider" />

        <a href="https://sibuzhome.com/e-katalog" target="_blank" rel="noopener noreferrer" className="mobile-catalog-btn" onClick={closeMenu}>
          {t('header.catalog')}
        </a>

        <div className="mobile-menu-divider" />

        <div className="mobile-social-links">
          <a href="https://www.instagram.com/sibuzhome/" target="_blank" rel="noopener noreferrer" className="mobile-social-link">
            <InstagramIcon />
          </a>
          <a href="https://www.facebook.com/profile.php?id=61581253865686" target="_blank" rel="noopener noreferrer" className="mobile-social-link">
            <FacebookIcon />
          </a>
          <a href="https://www.linkedin.com/company/sibuzhome" target="_blank" rel="noopener noreferrer" className="mobile-social-link">
            <LinkedInIcon />
          </a>
        </div>
      </div>
    </>
  );
}
